import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

const REGRA_KM_BAIXO = 2;
const TIPO_EXCESSO_ATIVIDADE = 3;

const CRITERIOS: Record<number, string> = {
  1: 'sem ligar',
  2: 'sem sair do lugar',
  3: 'sem ligar e sem sair do lugar',
};

interface Props { entidade: any; }

// Frase viva que traduz a configuração da regra de inatividade para o operador,
// atualizada conforme ele altera os campos.
const ExplicacaoInatividade: React.FC<Props> = ({ entidade }) => {
  const regra = Number(entidade?.regraInatividade) || 1;
  const ehExcesso = Number(entidade?.tipo) === TIPO_EXCESSO_ATIVIDADE;

  let frase: React.ReactNode;
  if (ehExcesso) {
    const janela = Number(entidade?.janelaDias) || 0;
    const km = Number(entidade?.kmMaximo) || 0;
    const media = janela > 0 ? km / janela : 0;
    const mediaTexto = (Math.round(media * 10) / 10).toLocaleString('pt-BR');
    frase = janela > 0 && km > 0 ? (
      <>
        O alerta será acionado quando um veículo alugado rodar{' '}
        <strong>mais de {km} km</strong> somados nos{' '}
        <strong>últimos {janela} dias</strong>, o equivalente a uma média acima de{' '}
        <strong>{mediaTexto} km por dia</strong>. Ele se resolve sozinho quando o uso
        voltar a ficar dentro desse limite.
      </>
    ) : (
      <>Preencha a janela de dias e o km máximo para ver quando o alerta será acionado.</>
    );
  } else if (regra === REGRA_KM_BAIXO) {
    const janela = Number(entidade?.janelaDias) || 0;
    const km = Number(entidade?.kmMinimo) || 0;
    const media = janela > 0 ? km / janela : 0;
    const mediaTexto = (Math.round(media * 10) / 10).toLocaleString('pt-BR');
    frase = janela > 0 && km > 0 ? (
      <>
        O alerta será acionado quando um veículo alugado rodar{' '}
        <strong>menos de {km} km</strong> somados nos{' '}
        <strong>últimos {janela} dias</strong>, o equivalente a uma média abaixo de{' '}
        <strong>{mediaTexto} km por dia</strong>. Ele se resolve sozinho assim que o
        veículo voltar a atingir essa quilometragem.
      </>
    ) : (
      <>Preencha a janela de dias e o km mínimo para ver quando o alerta será acionado.</>
    );
  } else {
    const dias = Number(entidade?.diasInativos) || 0;
    const criterio = CRITERIOS[Number(entidade?.criterioInatividade)] || CRITERIOS[1];
    frase = dias > 0 ? (
      <>
        O alerta será acionado quando um veículo alugado passar{' '}
        <strong>{dias} {dias === 1 ? 'dia seguido' : 'dias seguidos'} {criterio}</strong>.
        Qualquer dia de uso zera a contagem, e o alerta se resolve sozinho quando o
        veículo voltar a ser usado.
      </>
    ) : (
      <>Preencha os dias inativos para ver quando o alerta será acionado.</>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 10,
      background: '#f4f7fb', border: '1px solid #dde5ef', borderLeft: '3px solid #1F467E',
      borderRadius: 6, padding: '10px 14px', fontSize: 13.5, color: '#33475b', lineHeight: 1.5,
    }}>
      <MdInfoOutline size={18} color="#1F467E" style={{ flexShrink: 0, marginTop: 1 }} />
      <span>{frase}</span>
    </div>
  );
};

export default ExplicacaoInatividade;
